/**
 * Asynchronously loads the component for CreateSamplePage
 */

import { lazyLoad } from 'utils/loadable';

export const LinkCard = lazyLoad(
  () => import('./index'),
  module => module.default,
);
